module.exports = __webpack_public_path__ + "assets/img/confirm-green.52269eb7.svg";